import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Box } from '@mui/material';
import { Delete as DeleteIcon, Image as ImageIcon } from '@mui/icons-material';
import { red } from '@mui/material/colors';
import RegularButton from "components/CustomButtons/Button";
import { getDeleteExpense, checkAvailability, setErrorSnackbar, checkImage } from 'redux/ducks/expenses';
import { useToggle } from 'hooks/useToggle';
import { ModalV2 } from 'components/Modal/ModalV2';
import { formatNumber } from 'helpers/getNumberFormats';

const configTable = [
  {
    Header: "Fecha",
    accessor: "date",
    filterable: true,
    filterMethod: (filter, row) =>
      row.date.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Planta",
    accessor: "station",
    filterable: true,
    filterMethod: (filter, row) =>
      row.station.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Porcentaje",
    accessor: "percentage",
    filterable: true,
    Cell: props => props.value != null ? `% ${props.value}` : null
  },
  {
    Header: "Categoria",
    accessor: "category",
    filterable: true,
    filterMethod: (filter, row) =>
      row.category.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Importe Planta",
    accessor: "amountByStationC",
    Cell: ({ original }) => <div>{formatNumber(original?.amountByStationC, "$", true)}</div>
  },
  {
    Header: "Importe Gasto",
    accessor: "amountC",
    Cell: ({ original }) => <div>{formatNumber(original?.amountC, "$", true)}</div>
  },
  {
    Header: "Acciones",
    accessor: "id",
    sortable: false,
    filterable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch()
      const { stations, companies } = useSelector(state => state.companies)
      const { images } = useSelector(({ expenses }) => expenses)

      const [open, setOpen] = useToggle()
      const [openImg, setOpenImg] = useToggle()
      const handleDelete = () => {
        dispatch(getDeleteExpense(original, dispatch, setOpen))
      }

      const handleOpenModalDelete = async () => {

        let idCompany = original?.idStation && Object.keys(stations).length > 0 ? stations[original?.idStation]?.id_company : null
        let company = idCompany ? companies[idCompany] : null
        if (company) {
          const isOpenDate = await dispatch(checkAvailability(original?.date, company))
          if (isOpenDate) {
            setOpen()
          }
        }
        else {
          dispatch(setErrorSnackbar({ colorError: "danger", errorMessage: "No se encontro empresa." }))
        }
      }

      const handleOpenModalImg = async () => {
        dispatch(checkImage(original?.id, setOpenImg))
      }

      return (
        <>
          <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
            <RegularButton
              justIcon
              round
              color="transparent"
              onClick={handleOpenModalImg}
              tooltip="Ver fotos"
            >
              <ImageIcon color='info' />
            </RegularButton>
            <RegularButton
              justIcon
              round
              color="transparent"
              onClick={handleOpenModalDelete}
            >
              <DeleteIcon style={{ color: red[500] }} />
            </RegularButton>
          </div>
          <ModalV2
            open={open}
            onClose={setOpen}
            justConfirm
            title={`Desea eliminar gasto del ${original?.date}?`}
          >
            <div style={{
              width: '100%',
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 8
            }}>
              <RegularButton
                color="info"
                onClick={setOpen}
              >
                Cancelar
              </RegularButton>
              <RegularButton
                color="danger"
                onClick={handleDelete}
              >
                Eliminar
              </RegularButton>

            </div>
          </ModalV2>
          <ModalV2
            open={openImg}
            onClose={setOpenImg}
            justConfirm
            title="Imágenes del gasto"
          >
            <Box sx={{ width: '100%', maxHeight: '70vh', overflowY: 'auto', p: 1 }}>
              <Grid container spacing={2} justifyContent="center">
                {images.map((src, index) => (
                  <Grid item xs={12} sm={images.length === 1 ? 12 : 6} key={index}>
                    <img
                      src={src}
                      alt={`Imagen ${index + 1}`}
                      style={{
                        width: '100%',
                        maxHeight: '60vh',
                        objectFit: 'contain',
                        borderRadius: 8,
                        display: 'block',
                        margin: '0 auto'
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </ModalV2>
        </>
      )
    },
  }
];

const tableHeaders = ['Planta', 'Porcentaje', 'Editar'];

export { configTable, tableHeaders };
